import ContentWrapper from "@components/ContentWrapper/ContentWrapper";
import { TrendTab } from "@core/constants";
import { FCX } from "@datassential/platform-ui-lib";
import TrendContextProvider, { useTrendContext } from "@pages/Trend/TrendContext";
import TrendHeader from "@pages/Trend/components/Header";
import HistoricTrend from "@pages/Trend/components/HistoricTrend";
import TrendSummary from "@pages/Trend/components/TrendSummary";
import { SelectAmongContextProvider } from "@vms/SelectAmong/SelectAmongContext";
import { useCommonDataContext } from "@core/CommonDataContext";
import Loader from "@components/Loader";
import SelectFiltersProvider from "@vms/SelectFilters/SelectFiltersContext";

const TrendWithContext = () => {
    const {
        activeTab,
    } = useTrendContext();

    return (
        <ContentWrapper className="Trend">
            <TrendHeader/>
            <HistoricTrend isVisible={activeTab === TrendTab.HistoricTrend}/>
            <TrendSummary isVisible={activeTab === TrendTab.TrendSummary}/>
        </ContentWrapper>
    );
};

const Trend: FCX = () => {
    const { isLoading } = useCommonDataContext();

    if (isLoading) {
        return <Loader/>;
    }

    return (
        <TrendContextProvider>
            <SelectAmongContextProvider>
                <SelectFiltersProvider>
                    <TrendWithContext/>
                </SelectFiltersProvider>
            </SelectAmongContextProvider>
        </TrendContextProvider>
    )
}

export default Trend;